import type { ForgeUiAnalyticsAttributes } from '@atlassian/jira-forge-ui-types/src/common/types/analytics.tsx';
import type { Extension } from '@atlassian/jira-forge-ui-types/src/common/types/extension.tsx';
import type { EntryPoint } from '@atlassian/jira-forge-ui-types/src/common/types/module.tsx';
import { getForgeUIType } from '@atlassian/jira-forge-ui-utils-internal/src/utils/extension/index.tsx';
import { parseExtensionId } from '@atlassian/jira-forge-ui-utils-internal/src/utils/parse-extension-id/index.tsx';

export const getAnalyticsAttributesFromExtension = (
	extension: Extension,
	entryPoint?: EntryPoint,
): ForgeUiAnalyticsAttributes => {
	const { appId, envId } = parseExtensionId(extension.id);
	return {
		appId,
		envId,
		forgeType: getForgeUIType(extension, entryPoint),
		envType: extension?.environmentType,
	};
};
